(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/core/module/assets/javascripts/helpers/load-scripts.js') >= 0) return;  svs.modules.push('/components/core/module/assets/javascripts/helpers/load-scripts.js');
"use strict";


var helpers = svs.core.module.helpers;
function addScript(file, callback, container) {
  var scriptsrc = svs.core.config.data.svsconfig.cdn + file;
  var scriptElem = document.querySelector("script[src=\"".concat(scriptsrc, "\"]"));
  if (scriptElem) {
    if (!scriptElem.classList.contains('dynamic-js') || scriptElem.classList.contains('loaded')) {
      callback();
    } else {
      scriptElem.addEventListener('load', callback);
    }
    return;
  }

  var script = document.createElement('script');
  script.defer = true;
  script.async = false;
  script.type = 'text/javascript';
  script.className = 'dynamic-js';
  var isCallbackFired = false;
  script.addEventListener('error', function () {
    callback();
    helpers.logger.error("Failed to load script: ".concat(scriptsrc));
  });
  var onload = function onload() {
    if (!isCallbackFired) {
      isCallbackFired = true;
      script.classList.add('loaded');
      callback();
    }
  };

  script.addEventListener('load', onload);

  script.onreadystatechange = function () {
    if (this.readyState === 'complete') {
      onload();
    }
  };
  script.src = scriptsrc;
  helpers.logger.debug("Adding ".concat(file));
  container.appendChild(script);
}
function loadScripts(scripts, callback) {
  if (!scripts || scripts.length === 0) {
    if (callback) {
      callback();
    }
    return;
  }
  var container = document.createDocumentFragment();
  var loadedScripts = 0;
  var handleLoadedScript = function handleLoadedScript() {
    loadedScripts += 1;
    if (loadedScripts === scripts.length) {
      callback();
    }
  };
  scripts.forEach(function (script) {
    addScript(script, handleLoadedScript, container);
  });
  document.head.appendChild(container);
}
svs.core.module.helpers.loadScripts = loadScripts;

 })(window);